import React, {useEffect, useRef} from 'react';
import {isDesktop} from 'react-device-detect';
import _ from 'lodash';
import {getTabHeight} from '../../../../util/patientContextUtil';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) =>
    ({
        details: {
            height: ({height}) => 'calc(100vh - ' + height + 'px)',
            padding: '10px 10px',
            marginRight: '6px',
            overflowX: 'hidden',
        },
        detailsWithoutFooter: {
            height: ({height}) => 'calc(100vh - ' + height + 'px)',
        },
    }),
);

const EXCLUDE_SCROLL_TABS = ['ucr', 'ucrFiltered', 'dnacpr', 'links', 'history', 'observations', 'patient', 'sepsis'];

const TabPanelContext = (props) => {
    const tabScroll = useRef(null);
    const {children, value, index, scrollToBottom, idElement, hideScroll, ...other} = props;
    const classes = useStyles(getTabHeight(idElement));

    const isIpad = !isDesktop;
    const action = isIpad ? 'onorientationchange' : 'onresize';

    useEffect(() => {
        if (document.getElementById('tabContent'))
            document.getElementById('tabContent').style.height = (window.innerHeight - getTabHeight(idElement).height + 'px');

        window[action] = () => delayedCallback();

        return () => {
            window[action] = null;
        };
    }, []);

    useEffect(() => {
        const iid = setInterval(() => {
            if (tabScroll && tabScroll.current) {
                tabScroll.current.updateScroll();
            }
        }, 100);
        return () => {
            clearInterval(iid);
        };
    }, [tabScroll]);


    const delayedCallback = _.debounce(() => {
        if (document.getElementById('tabContent'))
            document.getElementById('tabContent').style.height = (window.innerHeight - getTabHeight(idElement).height + 'px');
    }, 800);

    return (
        <div
            role="tabpanel"
            className={EXCLUDE_SCROLL_TABS.includes(value) ? 'tabs-no-scroll' : 'tabs'}
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <div
                    id="tabContent"
                    className={EXCLUDE_SCROLL_TABS.includes(value) ? classes.detailsWithoutFooter : classes.details + ' scroll-normal-white'}
                    style={{overflowY: hideScroll ? 'hidden' : '', paddingTop: value === 'patient' ? 0 : '', position: 'relative'}}
                >
                    {children && children}
                </div>
            )}
        </div>
    );
};

export default TabPanelContext;